<template>
    <div>
        <div class="columns">
            <div class="column">
                <multiselect
                    v-model="form.user"
                    v-validate="'required'"
                    :options="participants.data.results || []"
                    :loading="participants.loading"
                    placeholder="Search user to select"
                    @search-change="search"
                    :custom-label="label"
                    select-label=""
                    track-by="id"
                    name="user"/>

                <p class="help is-danger">
                    {{ errors.first('user') }}
                </p>
            </div>

            <div class="column">
                <multiselect
                    v-model="form.role"
                    placeholder="Select role"
                    v-validate="'required'"
                    :options="roles"
                    track-by="value"
                    select-label=""
                    label="label"
                    name="role"/>

                <p class="help is-danger">
                    {{ errors.first('role') }}
                </p>
            </div>

            <div class="column is-narrow">
                <base-button
                    :loading="create.loading"
                    @click="submit"
                    class="is-primary add-button"
                    icon="fas fa-plus"
                    text="Add"/>
            </div>
        </div>

        <base-backend-errors :data="create.error"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import { roles } from '../../utils/constants';

export default {
    components: { Multiselect },
    props: ['space', 'topic'],
    data() {
        return {
            form: { user: null, role: null },
            roles,
        };
    },
    computed: {
        ...mapState('spaces', ['participants']),
        ...mapState('topic_members', ['create']),
    },
    methods: {
        label({ first_name, last_name }) {
            return `${first_name} ${last_name}`;
        },
        async submit() {
            const result = await this.$validator.validate();
            if (!result) return;

            await this.$store.dispatch('topic_members/create', {
                space_id: this.space.id,
                topic_id: this.topic.id,
                data: { role: this.form.role.value, user: this.form.user.id },
            });

            this.$emit('created', this.form);
            this.form.user = null;
            this.form.role = null;
            this.$validator.reset();
        },
        search(search) {
            this.$store.dispatch('spaces/participants', {
                space_id: this.space.id,
                hide_admins: true,
                search,
            });
        },
    },
};
</script>

<style scoped>
    .add-button {
        font-size: 1.1rem;
    }
</style>
